'use strict';

module.exports = (app) => app.directive('paginationBottom', /* @ngInject */ function() {
    return {
        restrict: 'E',
        scope: {
            page: '=',
			totalPages: '=',
			setPage: '=',
			uniteMaxPages: '=',
        },
		templateUrl: `./${BUILD_PATH}/pagination.bottom.directive.html`,
		controller: /* @ngInject */ function ($scope) {

			$scope.buttons = [];
			$scope.operators = {
				'>=': function(a, b) {return a >= b},
				'<=': function(a, b) {return a <= b},
				'>': function(a, b) {return a > b},
				'<': function(a, b) {return a < b},
				'': function(a,b) {return true}
			};

			init();

			/**
			 * Function to be executed on init. Generates the button objects and destructively
			 * fills the $scope.buttons variable
			 */
        	function init(){
        		var currentPageButton = {
        			value: 0,
					operator: '',
					value2: null,
					operator2: ''
        		};
				generateButton(5, -10, 1, '>=', '>');
				generateButton(5, -5, null, '>=', '');
				$scope.buttons.push(currentPageButton);
				generateButton(5, 1, null, '<=', '');
				generateButton(5, 6, -5, '<=', '<');
			}

			/**
			 * Creates objects which each represent a button. Destructively fills the scope variable $scope.buttons.
			 * @param nrOfButtons - the number of buttons the function shall generate
			 * @param startValue1 - the start for the first value. Gets incremented by every button
			 * @param startValue2 - the start for the second value. Gets incremented by every button
			 * @param operator1 - the first operator for the buttons
			 * @param operator2 - the second operator for the buttons
			 */
			function generateButton(nrOfButtons, startValue1, startValue2, operator1, operator2){
        		for(var i = 0; i < nrOfButtons; i++){
        			var button = {value: startValue1 + i, operator: operator1, value2: startValue2 !== null ? startValue2 + i : null, operator2: operator2};
        			$scope.buttons.push(button);
				}
			}

			/**
			 * Returns the needed limit to calculate whether a button shall be shown
			 * @param operator
			 * @returns number or null
			 */
        	$scope.getLimit = function(operator){
        		switch (operator) {
					case '>=':
						return 1;
					case '<=':
						return $scope.totalPages <= $scope.uniteMaxPages ? $scope.totalPages : $scope.uniteMaxPages;
					case '>':
						return $scope.totalPages <= $scope.uniteMaxPages ? $scope.totalPages : $scope.uniteMaxPages;
					case '<':
						return 1;
					case '':
						return null;
					default:
						break;
				}
			};

			/**
			 * executes parent functions after change of the select
			 */
			$scope.executeSetPage = function (page) {
				if(typeof $scope.setPage !== 'undefined'){
					$scope.setPage(page);
				}
			}
		}
    };
});
